import React, { useEffect, useRef, useState } from 'react';
import './Logs.css';

// Word banks for realistic NFT generation
const adjectives = [
    "Mystic", "Neon", "Cyber", "Pixel", "Ancient", "Galactic", "Shadow", "Enchanted",
    "Crimson", "Solar", "Quantum", "Frozen", "Ghostly", "Electric", "Meta", "Silent",
];

const characters = [
    "Tiger", "Alien", "Punk", "Wizard", "Robot", "Dragon", "Samurai", "Cat", "Monkey",
    "Fighter", "Knight", "Zombie", "Goblin", "Toad", "Golem", "Oracle", "Angel",
];

const collections = [
    "CryptoSavages", "MetaBeasts", "FutureVerse", "DreamChain", "RogueLabs", "ChainArtifacts",
    "PixelCitizens", "VerseRealms", "MoonGang", "DegenVerse", "AetherUnion", "BlastDAO",
];

const rarities = ["Common", "Uncommon", "Rare", "Epic", "Legendary", "Mythic"];

const generateRandomId = () => Math.random().toString(36).substring(2, 6).toUpperCase();

const generateRealisticMockNFTs = (count = 30) => {
    const nfts = [];

    for (let i = 0; i < count; i++) {
        const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
        const character = characters[Math.floor(Math.random() * characters.length)];
        const collection = collections[Math.floor(Math.random() * collections.length)];
        const rarity = rarities[Math.floor(Math.random() * rarities.length)];
        const id = generateRandomId();

        const name = `${adjective} ${character} #${Math.floor(Math.random() * 9999)}`;
        nfts.push({
            name,
            collection,
            rarity,
            id,
        });
    }

    return nfts;
};

// Generate logs using mock NFTs
const generateRandomLog = (nfts) => {
    if (!nfts || nfts.length === 0) {
        return {
            title: "No NFT",
            description: "No NFTs available to mine.",
            status: "none",
            collection: "N/A",
            id: "0000",
        };
    }

    const randomNFT = nfts[Math.floor(Math.random() * nfts.length)];
    const actions = [
        { text: 'successfully mined', status: 'success' },
        { text: 'failed to mine', status: 'failed' },
        { text: 'minting in progress', status: 'progress' },
        { text: 'transaction pending', status: 'pending' },
    ];
    const action = actions[Math.floor(Math.random() * actions.length)];

    return {
        title: randomNFT.name,
        description: `${randomNFT.name} from ${randomNFT.collection} (${randomNFT.rarity}) was ${action.text}.`,
        status: action.status,
        collection: randomNFT.collection,
        id: randomNFT.id,
    };
};

const Logs = ({ mining, setLogs, logs }) => {
    const logListRef = useRef(null);
    const [mockNFTs] = useState(generateRealisticMockNFTs(500)); // Static list of mock NFTs

    useEffect(() => {
        if (mining) {
            const interval = setInterval(() => {
                setLogs((prevLogs) => [
                    generateRandomLog(mockNFTs),
                    ...prevLogs.slice(0, 49),
                ]);
            }, 2000);
            return () => clearInterval(interval);
        }
    }, [mining, mockNFTs, setLogs]);

    useEffect(() => {
        if (logListRef.current) {
            logListRef.current.scrollTop = logListRef.current.scrollHeight;
        }
    }, [logs]);

    return (
        <div>
            <h3 className="logs-title">Activity Logs</h3>
            <div className="logs-container">
                <div className="log-list" ref={logListRef}>
                    {logs.length > 0 ? (
                        logs.map((log, index) => (
                            <div key={index} className={`log-item ${log.status}`}>
                                <div className="log-header">
                                    <span className="log-title">{log.title}</span>
                                    <span className={`log-status-pill ${log.status}`}>{log.status}</span>
                                </div>
                                <div className="log-meta">
                                    <span className="log-id">ID: #{log.id}</span>
                                    <span className="log-collection">{log.collection}</span>
                                </div>
                                <p className="log-description">{log.description}</p>
                            </div>
                        ))
                    ) : (
                        <p className="log-placeholder">No minting logs yet. Start minting to see updates.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Logs;
